<template>
  <div>

    <!-- <div>
      <Breadcrumbs
        :extraBreadcrumb="extraBreadcrumbItems"
        :class="breadcrumbClass"
      />
    </div> -->
    <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mb-2"
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
    <v-container fluid style="margin-top:-15px">
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Apply Canteen Facility</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>Child</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list"
              item-text="learner" item-value="id" label="Child" outlined persistent-hint hint="Please Select Child" />
          </v-col>

          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col col="12" sm="2" md="2" class="pt-6 mt-6" v-if="this.ay && this.child">
            <v-btn color="brand onBrand--text" @click="fetchData()">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <br />
      <v-card class="box" v-if="apply_payment_card">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Select Menu Type And Installment </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!-- <v-btn color="warning" @click="updateMenuType(item)">Change Menu</v-btn> -->
        </v-toolbar>

        <v-row class="pt-5 pb-5" justify="center" dense v-if="canteen_menutype_list != ''">
          <div class="mr-5"><b>Select Menu Type</b></div>
          <span v-for="(inst, index) in canteen_menutype_list" :key="index" class="radio-container">
            <input type="radio" class="radiospace" v-model="canteen_menutype" v-bind:value="inst"
              @change="setAMountValue(inst.id)" />
            {{ inst.name }}
          </span>

          <!-- {{menu_card}} -->
          <div class="mr-5" v-if="this.menu_card != null">
            <b class="pr-2">Menu Card</b>
            <!-- <span v-if="this.menu_card!=null"> -->
            <a class="p-2" :href="aws_path + this.menu_card" target="blank">
              <v-icon color="black">mdi-eye</v-icon>
            </a>
            <!-- </span>
                    <span v-else>
                        <span>--</span>
                    </span> -->
          </div>
          <div v-else>
            <span><b> Menu Card --</b></span>
          </div>
          <div class="pt-3">
            <center>
              <b>Note : Only one menu type is allowed for the selected
                installment, if parent wish to apply for both breakfast and
                lunch, please select 'breakfast & lunch' option from above menu
                type.</b>
            </center>
          </div>
        </v-row>
        <hr />
        <br />
        <v-row justify="center" dense v-if="!this.canteen_fee_sync && canteen_menutype != ''">
          <div class="mr-5"><b>Select Installment</b></div>
          <span v-for="(inst, index) in canteen_installments" :key="index" class="radio-container">
            <input type="radio" class="radiospace" v-model="canteen_installment" v-bind:value="inst"
              @change="setName(inst)" />
            {{ inst.name }}
          </span>
          <span v-if="show_datewise_flag === 'YES'" class="radio-container">
            <input type="radio" class="radiospace" v-model="canteen_installment" :value="{ id: -1 }"
              @change="setName({ id: -1 })" />
            Datewise
          </span>
        </v-row>
        <br />
        <v-row justify="center" v-if="show_month">
          <v-col cols="12" sm="3" md="3">
            <!-- <v-text-field outlined dense type="month" v-model="from_month" label="From Month" hint="From Month"></v-text-field> -->
            <template>
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="formattedMonth" label="From Month" hint="From Month" outlined dense readonly
                    v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="fromMonth" type="month" :min="minMonth" :max="maxMonth" no-title 
                  @input="menu = false" @change="setNameTerm()"></v-date-picker>
              </v-menu>
            </template>
          </v-col>
          <!-- <v-row justify="center" dense v-if="fromMonth">
                            <v-btn small color="warning" @click="setNameTerm()">Fetch</v-btn>
                        </v-row> -->
        </v-row>
        <v-row justify="center" v-if="show_dateRange">
          <v-col cols="12" sm="12" md="12" align="center">
            <span class="blinking-text">Note : The weekly bookings can be done for a week from Monday - Friday
              only.</span>
          </v-col>
          <!-- FROM DATE -->
          <v-col cols="12" sm="3" md="3">
            <v-menu ref="fromMenu" v-model="fromMenu" :close-on-content-click="false" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="fromDate" label="From Date" prepend-icon="mdi-calendar" outlined dense readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="fromDate" @change="onFromDateSelected"
                :min="new Date().toISOString().substr(0, 10)" :allowed-dates="allowedFromDates" />
            </v-menu>
          </v-col>
          <!-- TO DATE -->
          <v-col cols="12" sm="3" md="3">
            <v-menu ref="toMenu" v-model="toMenu" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="toDate" label="To Date" prepend-icon="mdi-calendar" outlined dense readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="toDate" :allowed-dates="allowedToDates" @change="getFeesByDate()"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <center v-if="installment_from_date && installment_to_date && show_fees">
          <span v-if="canteen_installment">
            <!-- <b>Installment Period - From :{{installment_from_date}} To :{{installment_to_date}}</b> -->
            <b>Installment Ends On - {{ installment_to_date }}</b>
          </span>
          <br />
        </center>

        <v-row justify="center" dense v-if="show_fees">
          <p class="pt-1">
            <b>Installment Fees In Rs.</b> {{ fees_applicable }}
          </p>
        </v-row>
        <hr v-if="show_fees" />
        <br v-if="show_fees" />
        <v-row justify="center" dense v-if="show_fees && fees_applicable != ''">
          <v-btn small color="warning" @click="SaveCanteenInstallment()">Apply</v-btn>
        </v-row>
        <center v-if="fromDate && toDate">
          <span v-if="canteen_installment">
            <b>Installment Ends On - {{ toDate }}</b>
          </span>
          <br />
        </center>

        <v-row justify="center" dense v-if="showTotalDailyFees && totalDailyFees != ''">
          <p class="pt-1">
            <b>Installment Fees In Rs.</b> {{ totalDailyFees }}
          </p>
        </v-row>
        <hr v-if="showTotalDailyFees && totalDailyFees != ''" />
        <br v-if="showTotalDailyFees && totalDailyFees != ''" />
        <v-row justify="center" dense v-if="showTotalDailyFees && totalDailyFees != ''">
          <v-btn small color="warning" @click="SaveCanteenInstallment()">Apply</v-btn>
        </v-row>
      </v-card>

      <v-card class="box" v-if="this.learner_canteen_installments != ''">
        <v-data-table :headers="headers" dense class="elevation-1" :items="learner_canteen_installments">
          <template v-slot:top>
            <v-toolbar flat dense class="toolbar">
              <v-toolbar-title>Canteen-Installment Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>

          <template v-slot:[`item.is_approved`]="{ item }">
            <!-- {{item.is_approved}} -->
            <!-- <span v-if="item.is_approved && item.can_make_payment" > -->
            <span v-if="item.is_approved">
              <!-- <span v-if="item.ispaid == true"> -->
              <span v-if="item.amount_to_pay <= 0">
                <strong>Already Paid</strong>
              </span>
              <span v-else>
                <form :action="url" @submit="payment" name="paytmform" method="POST">
                  <input type="hidden" :value="item.orgid" name="orgid" />
                  <input type="hidden" :value="item.tenantid" name="tenantid" />
                  <input type="hidden" :value="item.uid" name="uid" />
                  <input type="hidden" :value="item.learner_id" name="studid" />
                  <input type="hidden" :value="item.amount_to_pay" name="fee_amount" />
                  <input type="hidden" :value="item.ay" name="ay" />
                  <input type="hidden" :value="'Canteen - ' + item.name" name="purpose" />
                  <input type="hidden" :value="item.learner_canteen_fees_installment_id"
                    name="learner_canteen_fees_installment_id" />
                  <input type="hidden" :value="item.learner_canteen_fees_installment_id" name="json_pre_trans_data" />
                  <input type="hidden" :value="item.hash_val" name="hash_val" />
                  <input type="hidden" value="Create" name="flag" />
                  <v-btn small color="warning" type="submit" :disabled="isExpired(item.to_date)" :loading="loader">Pay</v-btn>
                </form>
              </span>
            </span>
          </template>
          <template v-slot:[`item.print`]="{ item }">
            <span v-for="item in item.receipt_no" :key="item">
              <v-tooltip top color="warning">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" v-on="on"
                    @click="print(item, item.ay)">
                    <v-icon color="warning">mdi-printer</v-icon>{{ item }}</v-btn>
                </template>
                <span> Print Fee Receipt!!! </span>
              </v-tooltip>
            </span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-row justify="left" dense>
              <v-col col="12" sm="10" md="10">
                <span v-if="item.can_change_menutype">
                  <v-btn small color="warning" :disabled="isExpired(item.to_date)" @click="editMenu(item)">Change Menu</v-btn>
                </span>
                <span v-else><b>Cannot Change</b></span>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.cancel_installment`]="{ item }">
            <span v-if="item.delete_fees_installment == true">
              <v-btn small color="warning" :disabled="isExpired(item.to_date)" @click="requestCanteenInstallmentCancel(item)">Cancel</v-btn>
            </span>
            <span v-else><b> Fees Paid...Cannot Cancel </b></span>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="editDialog" max-width="1000px">
        <v-card v-if="this.editItem">
          <v-toolbar class="toolbar no-display" flat dense>
            <v-toolbar-title>
              <strong> Change Menu </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab small color="white" outlined icon @click="editDialog = false"><v-icon> mdi-close
              </v-icon></v-btn>
          </v-toolbar>
          <!-- {{ this.editItem }} -->
          <v-row dense justify="center" v-if="this.editItem">
            <v-col cols="12" sm="3" md="3">
              <p><b>Installment : </b> {{ this.editItem.name }}</p>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <p><b>Menu Taken : </b> {{ this.editItem.canteenmenutype }}</p>
            </v-col>
          </v-row>
          <v-row dense justify="center" v-if="this.editItem">
            <v-col cols="12" sm="3" md="3">
              <p><b>From Date : </b> {{ this.editItem.from_date }}</p>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <p><b>To Date : </b> {{ this.editItem.to_date }}</p>
            </v-col>
          </v-row>
          <v-row dense justify="center" v-if="this.editItem">
            <v-col cols="12" sm="3" md="3">
              <p><b>Amount : </b> {{ this.editItem.amount }}</p>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <p><b>Amount Paid: </b> {{ this.editItem.paid_till_now }}</p>
            </v-col>
          </v-row>

          <v-row dense justify="center" v-if="this.editItem">
            <v-col cols="12" sm="3" md="3">
              <p>
                <b>Updated Menu Will Be : </b>
                {{ this.editItem.changed_menutype }}
              </p>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <p><b>Final Amount : </b> {{ this.editItem.final_amount }}</p>
            </v-col>
          </v-row>

          <!-- receipt id-{{ receipt_id }} <br /> -->
          <center>
            <strong>Are you sure you want to update menu???</strong>
          </center>
          <v-row justify="center">
            <v-btn class="button" text @click="editDialog = false">Cancel</v-btn>
            <form :action="url" @submit="payment" name="paytmform" method="POST">
              <input type="hidden" :value="this.editItem.orgid" name="orgid" />
              <input type="hidden" :value="this.editItem.tenantid" name="tenantid" />
              <input type="hidden" :value="this.editItem.uid" name="uid" />
              <input type="hidden" :value="this.editItem.learner_id" name="studid" />
              <input type="hidden" :value="this.editItem.final_amount" name="fee_amount" />
              <input type="hidden" :value="this.editItem.ay" name="ay" />
              <input type="hidden" :value="this.editItem.name" name="purpose" />
              <input type="hidden" :value="this.editItem.learner_canteen_fees_installment_id"
                name="learner_canteen_fees_installment_id" />
              <input type="hidden" :value="this.json_pre_trans_data" name="json_pre_trans_data" />
              <input type="hidden" :value="this.editItem.hash_val_2" name="hash_val" />
              <input type="hidden" value="Update" name="flag" />
              <v-btn text class="mt-2 button" type="submit" :loading="loader">Pay</v-btn>
            </form>
            <!-- <v-btn class="button" text>Pay</v-btn> -->
          </v-row>
        </v-card>
      </v-dialog>
      <!-- <v-dialog v-model="show_month" v-if="show_month" max-width="1000px">
                 <v-toolbar class="toolbar no-display" flat dense>
                        <v-toolbar-title>
                            <strong> Month </strong>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn fab small color="white" outlined icon @click="editDialog = false"><v-icon> mdi-close </v-icon></v-btn>
                    </v-toolbar>
                     <v-row dense justify="center" v-if="this.editItem">
                        <v-col cols="12" sm="3" md="3">
                
                        </v-col>
                     </v-row>
            </v-dialog> -->
    </v-container>
   <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Apply Canteen Facility Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/BBMgi0lzsZ0?si=JA0Q_7nfUNul3mfB"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    extraBreadcrumbItems: [],
    breadcrumbClass: "breadcrumb-style1",
    videoDialog:false,
    menu: false,
    installment_id: "",
    fromMonth: null,
    // minMonth: new Date().toISOString().slice(0, 7),
    /* maxMonth: new Date(new Date().setMonth(new Date().getMonth() + 1))
       .toISOString()
       .slice(0, 7), */
    minMonth: "",
    maxMonth: "",
    from_month: "",
    canteen_fee_sync: false,
    loader: false,
    radios: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    menu_card: null,
    json_pre_trans_data: [],
    change_menu_type: null,
    datewise_day_limit: null,
    show_datewise_flag: null,
    fromMenu: false,
    toMenu: false,
    fromDate: "",
    toDate: null,
    datewise_day_limit_value: "",
    max_days_canteen_value: "",
    max_days_canteen: null,
    headers: [
      { text: "Sr No", value: "srno" },
      { text: "Installment", value: "name" },
      // { text: "From Date", value: "from_date" },
      { text: "Applied Date", value: "applied_date" },
      { text: "Ends On", value: "to_date" },
      { text: "Amount", value: "amount" },
      { text: "Applied For", value: "canteenmenutype" },
      // { text: "Change Menu", value: "action" },
      { text: "Paid Till Now", value: "paid_till_now" },
      { text: "Payment", value: "is_approved" },
      { text: "Print Receipt", value: "print" },
      { text: "Cancel", value: "cancel_installment" },
    ],
    ay_list: [],
    ay: "",
    child_list: [],
    child: "",
    show_fees: false,
    url: "",
    child_details: [],
    canteenFees: "",
    canteenFees_id: "",
    learner_canteen_fees_list: [],
    apply_payment_card: false,
    canteen_installments: [],
    canteen_installment: "",
    datewise_canteen_installment: "",
    show_fees: false,
    showTotalDailyFees: false,
    fees_applicable: "",
    totalDailyFees: "",
    learner_canteen_installments: [],
    aws_path: null,
    menu_card: null,
    canteen_menutype_list: [],
    canteen_menutype: "",
    installment_from_date: "",
    installment_to_date: "",
    editItem: null,
    editDialog: false,
    show_month: false,
    show_dateRange: false,
    daySequence: null,
  }),
  created() {
    this.url =
      process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_canteen";
    this.aws_path = localStorage.getItem("awspath");
  },
  computed: {
    formattedMonth() {
      return this.fromMonth
        ? new Date(this.fromMonth).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
        })
        : "";
    },
  },
  methods: {
    isExpired(toDate) {
      if (!toDate) return false;
      const today = new Date().setHours(0, 0, 0, 0); // normalize to midnight
      const endDate = new Date(toDate).setHours(0, 0, 0, 0);
      return endDate < today; // true if installment expired
    },
    getToday() {
      const today = new Date();
      return today.toISOString().substr(0, 10); // YYYY-MM-DD
    },
    onFromDateSelected(date) {
      this.fromDate = date;
      this.toDate = null; // reset to date when from date changes
      this.fromMenu = false;
    },
    getFeesByDate() {
      this.toMenu = false;
      const data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        installment: this.canteen_installment.id,
        canteen_menutype: this.canteen_menutype.id,
        ay: this.ay,
        child: this.child,
      };
      axios.post("/Canteen/getFeesByDate", data).then((res) => {
        if (res.data.flag == "YES") {
          this.totalDailyFees = res.data.totalFees;
          this.canteenFees_id = res.data.canteenFees_id;
          this.showTotalDailyFees = true;
        } else {
          this.showSnackbar("error", res.data.message);
        }
        this.overlay = false;
      });
    },
    allowedFromDates(date) {
      const day = new Date(date).getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
      return day === this.daySequence - 1;
    },
    allowedToDates(date) {
      if (!this.fromDate) return true;

      const from = new Date(this.fromDate);
      const selected = new Date(date);

      const datewiseLimit = parseInt(this.datewise_day_limit_value.toString());
      const maxLimit = parseInt(this.max_days_canteen_value.toString());

      // Start: fromDate + datewise_day_limit_value
      const minDate = new Date(from);
      minDate.setDate(minDate.getDate() + datewiseLimit - 1);

      // End: fromDate + max_days_canteen_value - 1
      const maxDate = new Date(from);
      maxDate.setDate(maxDate.getDate() + maxLimit - 1);

      return selected >= minDate && selected <= maxDate;
    },
    requestCanteenInstallmentCancel(item) {
      if (!confirm("Are You Sure You Want To Cancel...?")) return;
      const data = {
        feesinstallmant_id: item.feesinstallmant_id,
      };
      this.overlay = true;
      axios
        .post("/Canteen/deleteLearnerCanteenInstallment", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Cancelled Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.fetchData();
        });
    },
    editMenu(item) {
      this.editItem = item;
      this.json_pre_trans_data = JSON.stringify(
        this.editItem.json_pre_trans_data
      );
      this.editDialog = true;
    },
    SaveCanteenInstallment() {
      if (!confirm("Are You Sure You Want To Apply...?")) return;
      const isDatewise = this.canteen_installment.id == -1;
      const data = {
        academicYear: this.ay,
        learner: this.child_details[0].lid,
        canteen_installment: !isDatewise ? this.canteen_installment.id : null,
        fees_applicable: !isDatewise
          ? this.fees_applicable
          : this.totalDailyFees,
        canteen_menutype: this.canteen_menutype.id,
        canteenFees_id: this.canteenFees_id,
        fromMonth: this.show_month ? this.fromMonth : null,
        end_date: isDatewise ? this.toDate : this.installment_to_date,
        canteeninstallmenttype: isDatewise
          ? "Datewise"
          : this.canteen_installment.canteeninstallmenttype,
        fromDate: isDatewise ? this.fromDate : null,
      };
      this.overlay = true;
      axios
        .post("/Canteen/SaveLearnerCanteenInstallmentWws", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //  this.transport_installments = res.data.transport_installments;
            this.learner_canteen_installments =
              res.data.learner_canteen_installments;
            this.showSnackbar("green", "Applied Successfully...");
            this.apply_payment_card = false;
            this.resetData();
          } else if (res.data.flag == "No") {
            this.apply_payment_card = false;
            this.showSnackbar("red", res.data.snackbar);
            this.resetData();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.resetData();
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.apply_payment_card = false;
          this.resetData();
        });
    },
    resetData() {
      this.show_fees = false;
      this.showTotalDailyFees = false;
      this.canteen_installment = "";
      this.canteen_menutype = "";
      this.fees_applicable = "";
      this.fromMonth = null;
      (this.show_month = false),
        (this.show_dateRange = false),
        (this.fromDate = ""),
        (this.toDate = "");
    },
    print(receipt_no, ay) {
      this.receipt_no = receipt_no;
      this.$session.set("receipt_no", JSON.stringify(receipt_no));
      this.$session.set("ay", JSON.stringify(ay));
      let routeData = this.$router.resolve({ name: "canteen-receipt" });
      window.open(routeData.href, "_blank");
    },
    payment() {
      var formData = new FormData(paytmform);
      console.log("formData");
      console.log(formData);
      this.loader = false;
    },

    setAMountValue(canteen_menutype) {
      (this.fees_applicable = ""),
        (this.show_fees = false),
        (this.showTotalDailyFees = false),
        this.getMenuCard();
      if (!this.canteen_installment) {
        this.showSnackbar("red", "Please Select Installment..");
        return;
      }
      const data = {
        installment: this.canteen_installment.id,
        canteen_menutype: canteen_menutype,
        ay: this.ay,
        child: this.child,
        fromMonth: this.fromMonth,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getInstallmentAmountWWS", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fees_applicable = res.data.final_amount;
            this.canteenFees_id = res.data.canteenFees_id;
            this.installment_from_date = res.data.from_date;
            this.installment_to_date = res.data.to_date;
            this.menu_card = res.data.menu_card;
            this.show_fees = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getMenuCard() {
      const data = {
        canteen_menutype: this.canteen_menutype.id,
        ay: this.ay,
        child: this.child,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getMenuCard", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.canteenFees_id = res.data.canteenFees_id;
            this.installment_from_date = res.data.from_date;
            this.installment_to_date = res.data.to_date;
            this.menu_card = res.data.menu_card;
            // this.show_fees = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },

    setName(installment_name) {
      this.show_month = false;
      this.fromMonth = null;
      this.show_dateRange = false;
      this.fees_applicable = "";
      this.show_fees = false;
      this.showTotalDailyFees = false;
      //  this.fromDate = this.getToday();
      if (installment_name.id == -1) {
        this.installment_id = installment_name.id;
        this.show_dateRange = true;
        return;
      } else if (!installment_name.is_monthly) {
        this.installment_id = installment_name.id;
        this.show_month = true;
        this.minMonth = this.formatToMonth(installment_name.from_date);
        this.maxMonth = this.formatToMonth(installment_name.to_date);
        const currentMonth = new Date().toISOString().slice(0, 7);             
        // alert("currentMonth " + currentMonth)
        // alert("minMonth " + this.minMonth)
        let startMonth = this.minMonth;
        let endMonth = this.maxMonth;

        // Before the term starts, show only the starting month
        if (currentMonth < startMonth) {
          this.minMonth = startMonth;
          this.maxMonth = startMonth;
        }
        // Within the term period, show current + next month
        else if (currentMonth >= startMonth && currentMonth < endMonth) {
          this.minMonth = currentMonth;
          const nextMonth = this.getNextMonth(currentMonth);
          this.maxMonth = nextMonth <= endMonth ? nextMonth : endMonth;
        }
        // After term ends or during last month, show only last month
        else {
          this.minMonth = endMonth;
          this.maxMonth = endMonth;
        }
        return;
      }
      const data = {
        installment: installment_name.id,
        canteen_menutype: this.canteen_menutype.id,
        ay: this.ay,
        child: this.child,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getInstallmentAmountWWS", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fees_applicable = res.data.final_amount;
            this.canteenFees_id = res.data.canteenFees_id;
            this.installment_from_date = res.data.from_date;
            this.installment_to_date = res.data.to_date;
            this.menu_card = res.data.menu_card;
            this.show_fees = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    setNameTerm() {
      (this.fees_applicable = ""),
        (this.show_fees = false),
        (this.showTotalDailyFees = false);
      const data = {
        installment: this.installment_id,
        canteen_menutype: this.canteen_menutype.id,
        ay: this.ay,
        child: this.child,
        fromMonth: this.fromMonth,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getInstallmentAmountWWS", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fees_applicable = res.data.final_amount;
            this.canteenFees_id = res.data.canteenFees_id;
            this.installment_from_date = res.data.from_date;
            this.installment_to_date = res.data.to_date;
            this.menu_card = res.data.menu_card;
            this.show_fees = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    applyPaymentMethod(learner_transport_fees_id) {
      (this.fees_applicable = ""),
        (this.fees_applicable_origional = ""),
        (this.transport_installment = []),
        (this.show_fees = false),
        (this.showTotalDailyFees = false),
        (this.all_transport_installments = []); //chamged by mayur
      this.learner_transport_fees_amount_id = learner_transport_fees_id;
      const data = {
        learner_transport_fees_id: learner_transport_fees_id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/applyPaymentMethod", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fees_details.totalfees = res.data.totalfees;
            this.fees_details.paid_till_now = res.data.paid_till_now;
            this.fees_details.routestop = res.data.routestop;
            this.fees_details.route = res.data.route;
            this.fees_details.distanceslab = res.data.distanceslab;
            this.all_transport_installments = res.data.transport_installments;
            this.fees_applicable = res.data.totalfees;
            (this.fees_applicable_origional = res.data.totalfees),
              (this.learner_transport_fees_id =
                res.data.learner_transport_fees_id);
            // this.learner_transport_fees_installment_details =res.data.learner_transport_fees_installment_details;
            this.apply_payment_card = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    fetchData() {
      this.resetData();
      const data = {
        ay: this.ay,
        child: this.child,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getChildCanteenDetailsForWWS", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.child_details = res.data.child_details;
            this.canteenFees = res.data.canteenFees;
            this.change_menu_type = res.data.change_menu_type;
            this.datewise_day_limit_value = res.data.datewise_day_limit_value;
            this.datewise_day_limit = res.data.datewise_day_limit;
            this.show_datewise_flag = res.data.show_datewise_flag;
            this.max_days_canteen = res.data.max_days_canteen;
            this.max_days_canteen_value = res.data.max_days_canteen_value;
            this.daySequence = res.data.daysequence;

            if (res.data.change_menu_type == "YES") {
              if (this.headers.some((head) => head.value === "action")) {
              } else {
                this.headers.splice(6, 0, {
                  text: "Change Menu",
                  value: "action",
                  sortable: true,
                });
              }
            }
            // this.canteenFees_id = res.data.canteenFees_id;
            this.canteen_installments = res.data.canteen_installments;
            this.learner_canteen_installments =
              res.data.learner_canteen_installments;
            // this.menu_card = res.data.menu_card;
            this.apply_payment_card = true;
            this.canteen_menutype_list = res.data.canteen_menutype_list;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //  this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    formatToMonth(dateStr) {
      // Convert "31/May/2025" → "2025-05"
      const [day, monStr, year] = dateStr.split("/");
      const months = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
      };
      const month = months[monStr.substring(0, 3)];
      return `${year}-${month}`;
    },
    getNextMonth(yyyyMm) {
      // yyyyMm format = "2025-11"
      const [year, month] = yyyyMm.split("-").map(Number);
      let nextYear = year;
      let nextMonth = month + 1;
      if (nextMonth > 12) {
        nextMonth = 1;
        nextYear++;
      }
      return `${nextYear}-${String(nextMonth).padStart(2, "0")}`;
    },
    onLoad() {
      axios
        .post("ParentTransport/applyTransportFacility")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.child_list = res.data.learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },

  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.radiospace {
  /* margin: 1rem !important; */
  padding: 0%;
}

.radio-container {
  margin-right: 30px;
}

sub-row {
  border: 2px solid #424093;
  margin: 1rem;
  border-radius: 5px;
}

i {
  font-size: 20px !important;
}

.v-card__title {
  border: 1px solid #80808040;
  font-weight: bold;
  background-color: #424093;
  color: white;
  text-align: center;
  /* margin-top: 1.5rem; */
}

.card-border {
  border: 2px solid darkblue;
  border-radius: 10px;
  /* padding: 5px; */
  /* margin: 1rem !important; */
  width: auto;
}

.tx-bold {
  font-weight: bold;
  font-size: 14px;
  color: black;
}

i {
  font-size: 26px;
  cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #424093 !important;
  color: white !important;
  margin-top: 2.35rem;
  border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {}

.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}

.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}

v-simple-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: auto;
  border: 1px solid #ddd;
}

th {
  color: white;
  font-weight: bold;
  text-align: center !important;
}

td,
th {
  padding: 6px;
  border: 1px solid #ccc;
  text-align: center;
}

@media all and (max-width: 900px) {
  .padding-bot {
    padding: 8px;
  }
}

@media all and (min-width: 1000px) {
  .padding-metting {
    padding-right: 22px;
  }
}

@media (min-width: 320px) and (max-width: 350px) {
  .padding-bot {
    font-size: 11.6px;
  }
}

@media (min-width: 1000px) and (max-width: 1050px) {
  .padding-bot {
    font-size: 9.6px;
  }
}

.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}

.note-list {
  background-color: orange;
}

.blinking-text {
  font-size: 14px;
  display: inline-block;
  color: crimson;
  animation: zoom-animation 1.5s infinite alternate ease-in-out;
}

@keyframes zoom-animation {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.2);
  }
}
</style>
